import { apiPost } from '@/services/api/client';

export async function fetchShiftReportUrl(shiftId: string): Promise<string> {
  const body = await apiPost<{ url?: string; error?: string }>(
    'shiftUrl',
    { shiftId },
    { timeoutMs: 20_000 },
  );
  if (!body.url) throw new Error(body.error ?? 'URL indisponible.');
  return body.url;
}
